import { timeGroupsType } from "types";

const timeSelectValidation = (
  availableTimeGroups: timeGroupsType[]
): {
  status: boolean;
  times: timeGroupsType[];
} => {
  let times = [...availableTimeGroups];
  let status = true;
  for (let i = 0; i < times.length; i++) {
    let tempAvailableTimeGroup = times[i];
    let selected = tempAvailableTimeGroup.times.some((obj) => obj.selected == "on");
    times[i].error = selected ? "" : "on";
    if (!selected) {
      status = false;
    }
  }

  return { status, times };
};

export default timeSelectValidation;
